(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mega-menu"]) return;
  try {
    
    $('#mobile-shop-submenu').appendTo('#mobile-shop-menu');

  } catch(e) { console.error(e); }
})();
})();
